import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finance-fraud',
  templateUrl: './finance-fraud.component.html',
  styleUrls: ['./finance-fraud.component.scss']
})
export class FinanceFraudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}